import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`
const SUGARCOACH_BASE_URL = `${process.env.REACT_APP_BACKEND_HOST}`

const axiosInstance = axios.create()

//요청 가로채기
axiosInstance.interceptors.request.use(
  //요청 보내기전 수행
  async function (config) {
    const recoilValue = localStorage.getItem('recoil-persist')
    // console.log('recoilValue = ', recoilValue)
    if (recoilValue !== null) {
      const parserdRecoilValue = JSON.parse(recoilValue)
      // console.log('tokenInfo = ', parserdRecoilValue?.token)
      if (
        parserdRecoilValue !== null &&
        parserdRecoilValue?.token?.accessToken &&
        parserdRecoilValue?.token?.refreshToken
      ) {
        // config.headers['x-dy-accesstoken'] =
        //   parserdRecoilValue.token.accessToken
        // config.headers['x-dy-refreshToken'] =
        //   parserdRecoilValue.token.refreshToken
      }
    }
    return config
  },
  //오류 요청
  function (err) {
    return Promise.reject(err)
  },
)

/**
 * 이벤트 전체 조회
 * @returns
 */
export const getEventAttendances = async (params) => {
  const res = await axios.get(
    `${SUGARCOACH_BASE_URL}/v2/admin/events/attendances`,
    {
      params: params,
    },
  )
  return res
}

//이미지 파일 조회
export const getEventImage = async ({ category, uniqueId }) => {
  try {
    const res = await axiosInstance.get(
      `${SUGARCOACH_BASE_URL}/v2/admin/files`,
      {
        params: {
          category,
          uniqueId,
        },
      },
    )
    return res.data
  } catch (err) {
    console.error('getReviewImage ::', err)
    throw err
  }
}

//  이벤트 승인e
export const approveEvent = async (attendanceId) => {
  const res = await axios.get(
    `${SUGARCOACH_BASE_URL}/v2/admin/events/attendances/${attendanceId}/approve`,
  )
  return res
}

//  이벤트 거절
export const rejectEvent = async (attendanceId) => {
  const res = await axios.get(
    `${SUGARCOACH_BASE_URL}/v2/admin/events/attendances/${attendanceId}/reject`,
  )
  return res
}

/**
 * 이벤트 마스터 전체 조회
 * @returns
 */
export const getAllMasterEvents = async () => {
  const res = await axios.get(`${SUGARCOACH_BASE_URL}/v2/admin/events/master`)
  return res
}
/**
 * 특정 마스터 이벤트 조회
 * @returns
 */
export const getMasterEvent = async (eventId) => {
  const res = await axios.get(
    `${SUGARCOACH_BASE_URL}/v2/admin/events/master/${eventId}`,
  )
  return res
}
/**
 * 특정 마스터 이벤트 조회
 * @returns
 */
export const getMasterEventDetails = async (masterId) => {
  const res = await axios.get(
    `${SUGARCOACH_BASE_URL}/v2/admin/events/master/${masterId}/details`,
  )
  return res
}

/**
 * 마스터 이벤트 수정
 *
 */
export const updateMasterEvent = async (param) => {
  const res = await axios.post(
    `${SUGARCOACH_BASE_URL}/v2/admin/events/master/update`,
    param,
  )
  return res
}

/**
 * 마스터 이벤트 상세 수정
 */
export const updateMasterEventDetail = async (param) => {
  const res = await axios.post(
    `${SUGARCOACH_BASE_URL}/v2/admin/events/details/update`,
    param,
  )
  return res
}

/**
 * 마스터 이벤트 상세 순서/활성 업데이트
 */
export const updateMasterEventDetailSortOrder = async (masterId, param) => {
  const res = await axios.post(
    `${SUGARCOACH_BASE_URL}/v2/admin/events/masters/${masterId}/detail-sort`,
    param,
  )
  return res
}

/**
 * 이벤트 상세 생성
 */
export const createMasterEventDetail = async (param) => {
  const res = await axios.post(
    `${SUGARCOACH_BASE_URL}/v2/admin/events/details/create`,
    param,
  )
  return res
}

/**
 * 마스터 이벤트 아이디에 따른 참여자 수
 */
export const getEventAttendanceCount = async (masterId) => {
  const res = await axios.get(
    `${SUGARCOACH_BASE_URL}/v2/admin/events/${masterId}/attendance-count`,
  )
  return res.data
}
